import { css } from "styled-components";
import token from "styled-token";
import { spacingMixin } from "../spacingMixin";
import { buttonResetMixin } from "../buttonResetMixin";
import { focusMixin } from "../focusMixin";
import { hoverMediaQueryMixin } from "../hoverMediaQueryMixin";

var buttonCSS = function buttonCSS(props) {
  if (props.as !== "button") {
    return "";
  }

  return buttonResetMixin(props);
};

var inverseCSS = function inverseCSS(props) {
  if (!props.inverse) {
    return "";
  }

  return token("colors.white", function (color) {
    return css(["&,&:visited,&:hover,&:active{color:", ";}"], color);
  })(props);
};
/** @class AnchorMixin */

/** @method */


export var AnchorMixin = function AnchorMixin(props) {
  return token({
    focusColor: "colors.link",
    visitedColor: "colors.linkVisited",
    hoverColor: "colors.linkHover",
    activeColor: "colors.linkActive"
  }, function (_ref) {
    var focusColor = _ref.focusColor,
        visitedColor = _ref.visitedColor,
        hoverColor = _ref.hoverColor,
        activeColor = _ref.activeColor;
    return css(["cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;text-decoration:underline;&,&:focus{color:", ";}&:visited{color:", ";}", ";&:active{color:", ";}", " ", " ", " ", ""], focusColor, visitedColor, hoverMediaQueryMixin("\n                color: " + hoverColor + ";\n            "), activeColor, focusMixin(props), inverseCSS(props), buttonCSS(props), spacingMixin(props));
  })(props);
};